module.exports = __webpack_public_path__ + "img/header-bg-zhCn.97be1e87.png";